import { Button } from '@design-system/components/button/button';
import { Checkbox } from '@design-system/components/checkbox/checkbox';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

type PublishToBundleProps = {
  isOpen: boolean;
  close: () => void;
  publish: (programId: number) => void;
  setPublishToPlatformBundle: (value: boolean) => void;
  isPlatformBundleSelected: boolean;
  programId: number;
};

export const PublishToBundle = ({
  isOpen,
  close,
  publish,
  setPublishToPlatformBundle,
  isPlatformBundleSelected,
  programId,
}: PublishToBundleProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={close}
      title="Publish Program"
      disableBackdropClick={true}
      footerClassName="p-0"
      modalClassName="w-full md:w-[572px]"
      modalContentClassName="overflow-hidden"
    >
      <div className="flex flex-col gap-6">
        <Typography variant="body" size="large" fontWeight="normal">
          Do you want Platform Users to have access to this content you publish?
        </Typography>
        <div className="flex gap-6">
          <Checkbox
            textFontWeight="normal"
            textVariant="body"
            textSize="large"
            checked={true}
            disabled={true}
            onChange={() => null}
            checkboxVariant="neutral"
            label="Exclusive Access"
          />
          <Checkbox
            textFontWeight="normal"
            textVariant="body"
            textSize="large"
            checked={isPlatformBundleSelected}
            onChange={() =>
              setPublishToPlatformBundle(!isPlatformBundleSelected)
            }
            checkboxVariant="neutral"
            label="Platform Users"
          />
        </div>
        <div className="flex flex-col md:flex-row justify-between">
          <Button
            variant="text"
            color="neutral"
            onClick={close}
            className="w-full md:w-[254px]"
          >
            Cancel
          </Button>
          <Button
            onClick={() => publish(programId)}
            color="neutral"
            className="w-full md:w-[254px]"
          >
            Publish
          </Button>
        </div>
      </div>
    </Modal>
  );
};
